// extracted by mini-css-extract-plugin
var _1 = "FilterValueTags-moduletagBar__r8pUk TagBar-moduleTagBar__a7w7V";
export { _1 as "tagBar" }
